// src/components/CallingBot/CallingBot.tsx
import React, { useState } from "react";

// Types
interface PhoneNumber {
  id: string;
  label: string;
  number: string;
  icon: string;
}

// Phone numbers configuration
const phoneNumbers: PhoneNumber[] = [
  {
    id: "support",
    label: "Support",
    number: "+1 (321) 519-4247",
    icon: "💼",
  },
//   {
//     id: "support",
//     label: "Support",
//     number: "+1 (800) 234-5678",
//     icon: "🛠️",
//   },
//   {
//     id: "billing",
//     label: "Billing",
//     number: "+1 (800) 345-6789",
//     icon: "💳",
//   },
//   {
//     id: "emergency",
//     label: "Emergency",
//     number: "+1 (800) 456-7890",
//     icon: "🚨",
//   },
];

const CallingBot: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [copiedNumber, setCopiedNumber] = useState<string | null>(null);

  const toggleCallingBot = () => {
    setIsOpen(!isOpen);
  };

  const handleCall = (number: string) => {
    window.location.href = `tel:${number.replace(/\s/g, "")}`;
  };

  const copyToClipboard = async (number: string, e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(number.replace(/\s/g, ""));
      setCopiedNumber(number);
      setTimeout(() => setCopiedNumber(null), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="fixed bottom-24 right-5 z-[9999] font-arial">
      {/* Toggle Button - No pulse animation */}
      <button
        onClick={toggleCallingBot}
        className="
        w-14 h-14 rounded-full shadow-lg
        bg-gradient-to-r from-blue-600 to-purple-600
        hover:from-blue-700 hover:to-purple-700
        flex items-center justify-center
        transition-all duration-300 ease-in-out
        hover:scale-110 hover:shadow-xl
        focus:outline-none focus:ring-4 focus:ring-blue-300
        "
        aria-label="Toggle Calling Bot"
      >
        {isOpen ? (
          <svg
            className="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            className="w-5 h-5 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
          </svg>
        )}
      </button>

      {/* Small Dialog Box */}
      <div
        className={`
          absolute bottom-14 right-0
          w-[280px]
          bg-white dark:bg-gray-900
          rounded-2xl shadow-2xl
          overflow-hidden
          transition-all duration-300 ease-in-out
          ${
            isOpen
              ? "opacity-100 visible translate-y-0 scale-100"
              : "opacity-0 invisible translate-y-4 scale-95"
          }
        `}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
            </svg>
            <h3 className="font-semibold text-sm">Call Us</h3>
          </div>
          <button
            onClick={toggleCallingBot}
            className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Phone Numbers List */}
        <div className="p-3 space-y-2 max-h-[300px] overflow-y-auto">
          {phoneNumbers.map((phone) => (
            <div
              key={phone.id}
              onClick={() => handleCall(phone.number)}
              className="
                p-3 rounded-xl
                bg-gray-50 dark:bg-gray-800
                border border-gray-200 dark:border-gray-700
                hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-gray-700
                cursor-pointer
                transition-all duration-200
                flex items-center justify-between
                group
              "
            >
              <div className="flex items-center gap-3">
                <span className="text-lg">{phone.icon}</span>
                <div>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {phone.label}
                  </p>
                  <p className="text-sm font-semibold text-gray-800 dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                    {phone.number}
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex items-center gap-1">
                {/* Copy Button */}
                <button
                  onClick={(e) => copyToClipboard(phone.number, e)}
                  className="
                    w-8 h-8 rounded-full
                    bg-gray-200 dark:bg-gray-600
                    hover:bg-gray-300 dark:hover:bg-gray-500
                    flex items-center justify-center
                    transition-colors
                  "
                  title="Copy number"
                >
                  {copiedNumber === phone.number ? (
                    <svg
                      className="w-4 h-4 text-green-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600 dark:text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>

                {/* Call Button */}
                <div
                  className="
                    w-8 h-8 rounded-full
                    bg-gradient-to-r from-blue-600 to-purple-600
                    flex items-center justify-center
                    group-hover:scale-110
                    transition-transform
                  "
                >
                  <svg
                    className="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-4 py-2 bg-gray-50 dark:bg-gray-800 text-center border-t border-gray-200 dark:border-gray-700">
          <span className="text-[10px] text-gray-400">
            Tap a number to call • Powered by MyListIQ
          </span>
        </div>
      </div>
    </div>
  );
};

export default CallingBot;